// extracted by css-extract-rspack-plugin
export default {"container":"_1AjSgn6y8lcA5VkpS1SYz2","root":"_1rpFjEpprWCqLNJL-8v0P7","icon":"_1oCJs9FdhB0NsRDTCWbkGO","text":"_3BG7rQvzwHKREpf1w1vttQ"};